/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/search/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'desktop/search/app', exports: {} };
const exports = module.exports;



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import pagination from '@take-2/fd-modules/desktop/shared/pagination';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import searchEvents from '@take-2/fd-modules/desktop/search/events';

function run() {
    checkDependencies(module.name, debugLog);
    pagination.attach({ bypassClientLoading: true });
    searchEvents.attach();
}
run();
export default {  };